import { sleep } from "common/utils/sleep";

const fadeTransitionMs = 3000;
const hideTransitionMs = 5000;

// Configure with localStorage.debug_toasts = "true" to enable debug toasts
const debugToastsEnabled =
  typeof window !== "undefined" &&
  window.localStorage &&
  window.localStorage.getItem("debug_toasts") === "true";

/**
 * Shows a debug toast message if debug toasts are enabled.
 *
 * @param {string} message The message to show in the toast.
 */

export async function debugToast(message) {
  if (!debugToastsEnabled) {
    console.log(message);
    return;
  }

  let toast = document.getElementById("debug-toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.id = "debug-toast";
    toast.style.position = "fixed";
    toast.style.bottom = "8px";
    toast.style.right = "8px";
    toast.style.zIndex = "10000";
    document.body.appendChild(toast);
  }

  // Create new toast message element
  const messageElement = document.createElement("div");
  messageElement.style.margin = "4px";
  messageElement.textContent = message;
  messageElement.style.padding = "8px 12px";
  messageElement.style.backgroundColor = "rgba(0, 240, 0, 1)";
  messageElement.style.boxShadow = "2px 2px 2px rgba(0, 0, 0, 1)";
  messageElement.style.color = "black";
  messageElement.style.borderRadius = "4px";
  messageElement.style.transition = `opacity ${hideTransitionMs}ms ease-out, background-color ${fadeTransitionMs}ms ease-out`;
  toast.appendChild(messageElement);

  await sleep(300);

  // Transition to faded color
  messageElement.style.backgroundColor = "rgba(180, 180, 180, 1)";
  await sleep(fadeTransitionMs);

  // Fade out
  messageElement.style.opacity = "0";
  await sleep(hideTransitionMs);

  // Remove
  toast.removeChild(messageElement);
}
